const auth_api = {
  url: `${process.env.VUE_APP_GOOGLE_AUTH_URL}`,
}

let _fetch = false
if('true' == process.env.VUE_APP_GOOGLE_CLIENT_FETCH_BASIC_PROFILE.toLowerCase()){
  _fetch =  true
}

const client = {
  id: `${process.env.VUE_APP_GOOGLE_CLIENT_ID}`,
  scope: `${process.env.VUE_APP_GOOGLE_CLIENT_SCOPE}`,
  prompt: `${process.env.VUE_APP_GOOGLE_CLIENT_PROMPT}`,
  fetch_basic_profile: _fetch,
}

export {
  auth_api,  
  client
}
